import { useContext } from 'react'

import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'

import { Context as RelatedContentsContext } from '../../RelatedContentsContext'
import styles from './index.module.css'

interface Props {
  id: string
}

library.add(faLink)

const LinkRelated = ({ id }: Props) => {
  const { setContentId } = useContext(RelatedContentsContext)

  return (
    <Menu.Item>
      {({ active, ...props }) => (
        <button
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item
          )}
          onClick={() => setContentId(id)}
          {...props}
        >
          <FontAwesomeIcon className={styles.icon} icon={['fas', 'link']} />
          Contenuti correlati
        </button>
      )}
    </Menu.Item>
  )
}

export default LinkRelated
